"use strict";

(function () {
    EWS.DashboardItemTypesManager.add("PrivateBanner", {
        showEditButton: true,
        itemFields: ["DocumentID"],
        addItem(createNewItemCallback) {
            EWS.Document.SelectImages("Image", (documents, title) => {
                createNewItemCallback(title, {
                    DocumentID: documents
                });
            });
        },
        editItem(title, itemFields, dashboardItem, editItemCallback) {
            EWS.Document.SelectImages("Image", (documents, widgetTitle) => {
                editItemCallback(widgetTitle, {
                    DocumentID: documents
                });
            }, title, itemFields.DocumentID.split(",").join("^"));
        },
        onLoaded(dashboardItem) {
            EC_Fmt.LoadScript("Controls/swiper.js", () => {
                createSwiper(dashboardItem);
            });
            EC_Fmt.LoadScript("Controls/swiper.css");
        }
    });
    EWS.DashboardItemTypesManager.add("Banner", {
        showEditButton: true,
        itemFields: ["GlobalDocumentID"],
        addItem(createNewItemCallback) {
            EWS.Document.SelectImages("Image", (documents, title) => {
                createNewItemCallback(title, {
                    GlobalDocumentID: documents,
                    Edit: false
                });
            }, "", "", true);
        },
        editItem(title, itemFields, dashboardItem, editItemCallback) {
            EWS.Document.SelectImages("Image", (documents, widgetTitle) => {
                editItemCallback(widgetTitle, {
                    GlobalDocumentID: documents,
                    Edit: true
                });
            }, title, itemFields.GlobalDocumentID.split(",").join("^"), true);
        },
        onLoaded(dashboardItem) {
            EC_Fmt.LoadScript("Controls/swiper.js", () => {
                createSwiper(dashboardItem);
            });
            EC_Fmt.LoadScript("Controls/swiper.css");
        }
    });

    EWS.DashboardItemTypesManager.add("New Banner", {
        showEditButton: true,
        itemFields: ["GlobalDocumentID", "Edit", "Source"],
        async addItem(createNewItemCallback) {
            const global = await getDocumentPermission();
            EWS.Document.SelectImages("Image", (documents, title, source) => {
                createNewItemCallback(title, {
                    GlobalDocumentID: documents,
                    Edit: false,
                    Source: source
                });
            }, "", "", global, "NewBanner");
        },
        async editItem(title, itemFields, dashboardItem, editItemCallback) {
            const global = await getDocumentPermission();
            EWS.Document.SelectImages("Image", (documents, widgetTitle, source) => {
                editItemCallback(widgetTitle, {
                    GlobalDocumentID: documents,
                    Edit: true,
                    Source: source
                });
            }, title, itemFields.GlobalDocumentID.split(",").join("^"), global, "NewBanner", itemFields.Source);
        },
        onLoaded(dashboardItem, itemFields) {
            EC_Fmt.LoadScript("https://cdn.e8.co/GlobalDocs/660975.js", () => {
                EC_Fmt.LoadScript("Controls/swiper.js", () => {
                    createSwiper(dashboardItem, itemFields, "New Banner");
                });
            });
            EC_Fmt.LoadScript("Controls/swiper.css");
        }
    });

    async function createSwiper(dashboardItem, itemFields, type) {
        if (type === "New Banner") {
            const myRequest = new ECP.EC_Request("DashboardWidget_Banner");
            myRequest.SetReturnType(ECP.EC_ReturnType.Text);
            if (itemFields.Source === "Local") {
                myRequest.AddRequestVariable("DocumentID", itemFields.GlobalDocumentID);
            } else {
                myRequest.AddRequestVariable("GlobalDocumentID", itemFields.GlobalDocumentID);
            }

            myRequest.AddRequestVariable("Edit", itemFields.Edit);

            const html = await myRequest.Submit();
            dashboardItem.querySelector(".content").innerHTML = html;
        }

        const swiper = new Swiper(".swiper-container", {
            loop: true,
            autoplay: true,
            effect: "fade",
            slidesPerView: 2,
            centeredSlides: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            }
        });
    }

    async function getDocumentPermission() {
        const myRequest = new ECP.EC_Request("Banner_PermissionDocument");
        myRequest.SetReturnType(ECP.EC_ReturnType.Text);
        const value = await myRequest.Submit();
        if (value === "True") {
            return true;
        }
        return false;
    }
}());
